module.exports = __webpack_public_path__ + "img/celeb.b05be664.png";